import { Drawer, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { LanguageSwitch } from 'shared/components';

import ContactsLink from '../ContactsLink';
import CookiesButton from '../CookiesButton';
import FallbackLink from '../FallbackLink';
import LinkToPrivacy from '../LinkToPrivacy';
import ReportProblemButton from '../ReportProblemButton';
import MobileNavigationActionsList from './MobileNavigationActionsList';
import MobileNavigationHeader from './MobileNavigationHeader';
import SignOutButton from './SignOutButton';

interface NavigationSidePanelProps {
    open: boolean;
    toggleNav: () => void;
    onSelect: (path: string) => void;
}

export default function MobileNavigationSidePanel({ open, toggleNav, onSelect }: NavigationSidePanelProps) {
    return (
        <Root anchor="left"
            open={ open }
            onClose={ toggleNav }
        >
            <MobileNavigationHeader toggleNav={ toggleNav } />
            <MobileNavigationActionsList onSelect={ onSelect } />

            <BottomActions>
                <LanguageSwitch />
                <FallbackLink />
                <ContactsLink closeNav={ toggleNav } />
                <LinkToPrivacy />
                <CookiesButton />
                <ReportProblemButton />
                <SignOutButton />
            </BottomActions>
        </Root>
    );
}

const Root = styled(Drawer)(({ theme }) => ({
    '& .MuiDrawer-paper': {
        minWidth: theme.spacing(60),
        borderRadius: 0
    }
}));

const BottomActions = styled(Stack)(({ theme }) => ({
    marginTop: 'auto',
    padding: theme.spacing(8, 4),
    alignItems: 'baseline',
    rowGap: theme.spacing(2),

    hr: { width: '100%' },

    'a, button': {
        fontSize: '1.1rem'
    }
}));

